import { format } from 'date-fns';

const DEFAULT_PARAMS = {
    locale: 'eng',
    pattern: null
};

const formatMap = {
    rus: 'dd.MM.yyyy',
    eng: 'MM/dd/yyyy'
};

export default function formatDate(date, initialParams = {}) {
    const params = { ...DEFAULT_PARAMS, ...initialParams };
    const { locale } = params;
    const pattern = params.pattern || formatMap[locale];

    return format(new Date(date), pattern);
}
